import 'bootstrap';
import Splide from '@splidejs/splide';
import Parvus from 'parvus';
import parvusDe from 'parvus/src/l10n/de';
const prvs = new Parvus({
  l10n: parvusDe
});

import { klaroConfig } from './klaro-config';
import * as klaro from 'klaro';

// Klaro
klaro.render(klaroConfig);
document.querySelectorAll('[data-klaro-service]').forEach(el => {
  el.addEventListener('click', e => {
    klaro.getManager(klaroConfig).updateConsent(el.dataset.klaroService, true);
    klaro.getManager(klaroConfig).saveAndApplyConsents();
  });
});
document.querySelectorAll('[data-klaro-settings]').forEach(el => {
  el.addEventListener('click', e => {
    klaro.show(klaroConfig);
    e.preventDefault();
  });
});

// Navigation, Fixed
const siteHeader = document.querySelector('.site-header');
const siteHeaderNavbar = document.querySelector('.site-header__navbar');
const siteHeaderObserver = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if(entry.isIntersecting) {
      siteHeaderNavbar.classList.remove('is-out-of-banner');
    } else {
      siteHeaderNavbar.classList.add('is-out-of-banner');
    }
  });
});
siteHeaderObserver.observe(siteHeader);

// Navigation, Active
let pageId = document.body.dataset.id;
document.querySelectorAll('.navbar__nav li').forEach(nvItem => {
  if(nvItem.dataset.id == pageId) {
    nvItem.classList.add('a1');
    nvItem.setAttribute('aria-current', 'page');
  }
})


// Splides
Splide.defaults = {
  i18n: {
		prev: 'Vorheriges Slide',
		next: 'Nächstes Slide',
    slideX: 'Gehe zu Slide %s',
    pageX: 'Gehe zu Seite %s',
    select: 'Wähle eine Seite zum Anzeigen',
    slide: 'Slide',
    slideLabel: '%s von %s',
    carousel: 'Slider'
  },
};

// Artikel, Banner-Slider
const bannerSliders = document.querySelectorAll('.banner-slider');
bannerSliders.forEach(bannerSlider => {
  new Splide(bannerSlider, {
    perPage: 1,
    arrows: false
  }).mount();
});

// Artikel, Teaser, Columns
const teasersColumns = document.querySelectorAll('.teasers-columns');
teasersColumns.forEach(teaserColumns => {
  new Splide(teaserColumns, {
    perPage: 3,
    arrows: false,
    gap: 'var(--gutter)',
    pagination: true,
    breakpoints: {
      992: {
        perPage: 2
      },
      580: {
        perPage: 1
      }
    }
  }).mount();
});

// Galerie
const galleries = document.querySelectorAll('.gallery.splide');
galleries.forEach(gallery => {
  new Splide(gallery, {
    autoWidth: true,
    arrows: false,
    gap: 'calc(var(--gutter) / 2)',
    pagination: true,

  }).mount();
});


// Artikel, Veranstaltungen-Karte
document.querySelectorAll('.jiggy-eventsmap.splide').forEach((jiggyEventmapSplide, i) => {
  let markerTemplate = jiggyEventmapSplide.querySelector('.jiggy-eventsmap__markertemplate');
  let markerItem = markerTemplate.content.querySelector('*');

  let splide = new Splide(jiggyEventmapSplide, {
    perPage: 1,
    arrows: false,
    pagination: true,
    gap: 'var(--gutter)'
  });

  splide.on('pagination:mounted', data => {
    data.items.forEach((item, i) => {
      let coords = splide.Components.Elements.slides[i].dataset.position.split(',');
      let title = splide.Components.Elements.slides[i].dataset.title;
      item.button.title = title;
      item.button.classList.add('jiggy-eventsmap__marker');
      item.button.style.left = coords[0] + '%';
      item.button.style.top = coords[1] + '%';
      item.button.appendChild(document.importNode(markerItem, true));
    });
  });

  splide.mount();

});


// Artikel, Veranstaltungen, Filter
document.querySelectorAll('.articles-events').forEach(articles => {
  let id = articles.dataset.id;
  let articlesFilters = articles.querySelectorAll('.articles-events__filter a');
  let articlesList = articles.querySelectorAll('.articles-events__list .article-event');
  let quartersInfos = articles.querySelectorAll('.articles-events__info .article-quarters-info');
  let lastFilter = window.localStorage.getItem('filter-' + id);
  if(!(articlesFilters || articlesList)) return;

  articlesFilters.forEach(a => {
    a.addEventListener('click', e => {
      let filter = e.currentTarget.dataset.filter;
      let quartersName = e.currentTarget.innerHTML;
      window.localStorage.setItem('filter-' + id, quartersName);
      articlesFilters.forEach(a => {
        a.classList.remove('active');
      });
      e.currentTarget.classList.add('active');
      articlesList.forEach(article => {
        if(filter == '*' || filter == article.dataset.city) {
          article.removeAttribute('hidden');
        } else {
          article.setAttribute('hidden', 'hidden');
        }
      })
      quartersInfos.forEach(quarterInfo => {
        console.log(quartersName, quarterInfo.dataset.quarters, quartersName == quarterInfo.dataset.quarters)
        if(quartersName == quarterInfo.dataset.quarters) {
          quarterInfo.removeAttribute('hidden');
        } else {
          quarterInfo.setAttribute('hidden', 'hidden');
        }
      })
    });
  })

  if(lastFilter) {
    articlesFilters.forEach(a => {
      if(a.innerHTML == lastFilter) {
        a.click();
        return;
      }
    })
  }
});

// Artikel, Video, Modal
document.querySelectorAll('.article-video .modal').forEach((modal) => {
  let video = modal.querySelector('video');
  if(!video) return;
  
  modal.addEventListener('shown.bs.modal', (e) => {
    video.play();
  });
  modal.addEventListener('hide.bs.modal', (e) => {
    video.pause();
  });
});